module.exports = __webpack_public_path__ + "fonts/dk_plakkaat-webfont.a1fbf69c200077eb55e8441d72255e74.woff";